export enum VariationsSystemHelperText {
  VARIATIONS_BLOCKS = 'VARIATIONS_BLOCKS',
  VARIATIONS_LOGIC_BLOCKS = 'VARIATIONS_LOGIC_BLOCKS',
  NO_VARIATIONS = 'NO_VARIATIONS',
  SELECT_VARIATIONS = 'SELECT_VARIATION',
  VARIATIONS_CLAUSES = 'VARIATIONS_CLAUSES',
  VARIATIONS_LOGIC_CLAUSES = 'VARIATIONS_LOGIC_CLAUSES',
}

export const VARIATIONS_COPY_MAP: Record<VariationsSystemHelperText, string | null> = {
  [VariationsSystemHelperText.NO_VARIATIONS]: null,
  [VariationsSystemHelperText.VARIATIONS_BLOCKS]: 'This block has multiple variations',
  [VariationsSystemHelperText.VARIATIONS_CLAUSES]: 'This clause has multiple variations',
  [VariationsSystemHelperText.VARIATIONS_LOGIC_BLOCKS]: 'This block has multiple conditional variations',
  [VariationsSystemHelperText.VARIATIONS_LOGIC_CLAUSES]: 'This clause has multiple conditional variations',
  [VariationsSystemHelperText.SELECT_VARIATIONS]: 'Please choose one of the available variations',
};
